module.exports = __webpack_public_path__ + "bfa6c73222355775cad10065dd86c261.png";